export var ElementType;
(function (ElementType) {
    ElementType["Button"] = "button";
    ElementType["Label"] = "label";
    ElementType["TextInput"] = "TextInput";
    ElementType["Select"] = "select";
    ElementType["Slider"] = "slider";
    ElementType["CheckBox"] = "checkBox";
    ElementType["DatePicker"] = "datePicker";
    ElementType["Table"] = "table";
    ElementType["Link"] = "Link";
    ElementType["Component"] = "component";
    ElementType["New"] = "new";
})(ElementType || (ElementType = {}));
export var Systems;
(function (Systems) {
    Systems["Alert"] = "alert";
    Systems["Sidebar"] = "sidebar";
    Systems["Tooltip"] = "tooltip";
    Systems["Popup"] = "popup";
    Systems["Map"] = "map";
})(Systems || (Systems = {}));
